// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5bcf041b","453":"b7215503","667":"3eeaf350"}[chunkId] + ".chunk.js";
};